export type MappedSubscriptionStatus =
  | 'active'
  | 'cancelled'
  | 'past_due'
  | 'trialing'
  | 'incomplete';

/** Map Stripe subscription.status to LOAMIFY SubscriptionStatus. */
export function mapStripeSubscriptionStatus(stripeStatus: string): MappedSubscriptionStatus {
  switch (stripeStatus) {
    case 'active':
      return 'active';
    case 'trialing':
      return 'trialing';
    case 'past_due':
      return 'past_due';
    case 'canceled':
    case 'unpaid':
      return 'cancelled';
    case 'incomplete':
    case 'incomplete_expired':
      return 'incomplete';
    default:
      return 'incomplete';
  }
}

/** Whether Stripe status grants Creator Plan access (active or trialing). */
export function stripeStatusGrantsCreatorAccess(stripeStatus: string): boolean {
  return stripeStatus === 'active' || stripeStatus === 'trialing';
}

/** Map subscription status to creator setupStatus for lifecycle sync. */
export function creatorSetupStatusFromSubscription(
  subscriptionStatus: MappedSubscriptionStatus,
): 'active' | 'past_due' | 'canceled' | 'checkout_started' {
  switch (subscriptionStatus) {
    case 'active':
    case 'trialing':
      return 'active';
    case 'past_due':
      return 'past_due';
    case 'cancelled':
      return 'canceled';
    default:
      return 'checkout_started';
  }
}

export function isBillingDevStubEnabled(): boolean {
  const raw = process.env.BILLING_DEV_STUB;
  if (raw === 'false' || raw === '0') return false;
  if (raw === 'true' || raw === '1') return true;
  return !process.env.STRIPE_SECRET_KEY?.trim();
}
